import React, { useContext } from 'react';
import { Box, CircularProgress } from '@mui/material';
import { Navigate } from 'react-router-dom';
import { UserContext } from '../views/authentication/auth/UserContext';
import { getStoredAuthValue } from 'src/views/authentication/auth/authStorage';
import { getPostSignupRedirect } from 'src/views/authentication/auth/signupOnboarding';

const parseStoredBoolean = (value) => {
  const normalized = String(value ?? '').trim().toLowerCase();
  if (!normalized) return null;
  if (normalized === 'true') return true;
  if (normalized === 'false') return false;
  return null;
};

const RoleBasedRedirect = () => {
  const { user } = useContext(UserContext);
  const storedRole = getStoredAuthValue('userRole');
  const storedTenantId = getStoredAuthValue('tenantID');
  const storedOnboardingStep = getStoredAuthValue('onboardingStep');
  const storedIsOnboardingComplete = parseStoredBoolean(getStoredAuthValue('isOnboardingComplete'));
  const storedIsBusinessVerified = parseStoredBoolean(getStoredAuthValue('isBusinessVerified'));
  const storedIsEmailVerified = parseStoredBoolean(getStoredAuthValue('isEmailVerified'));
  const role = user?.role || storedRole;
  const tenantId = user?.tenantId || storedTenantId;

  if (!role) {
    return (
      <Box sx={{ height: '90vh', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
        <CircularProgress />
      </Box>
    );
  }

  const target = getPostSignupRedirect({
    ...user,
    role,
    tenantId,
    onboardingStep: user?.onboardingStep || storedOnboardingStep,
    isOnboardingComplete: Object.prototype.hasOwnProperty.call(user || {}, 'isOnboardingComplete')
      ? user.isOnboardingComplete
      : storedIsOnboardingComplete,
    isBusinessVerified: Object.prototype.hasOwnProperty.call(user || {}, 'isBusinessVerified')
      ? user.isBusinessVerified
      : storedIsBusinessVerified,
    isEmailVerified: Object.prototype.hasOwnProperty.call(user || {}, 'isEmailVerified')
      ? user.isEmailVerified
      : storedIsEmailVerified,
  });
  return <Navigate to={target} replace />;
};

export default RoleBasedRedirect;
